export class UserContactInfo {
    userId: string;
    salutationCode: string;
    firstName: string;
    middleName: string;
    lastName: string;
    displayName: string;
    dateOfBirth: Date;
    gender: string;
    email: string;
    mobile: string;
}


// WEBPACK FOOTER //
// ./src/app/models/userContactInfo.ts